var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('center-title',[_vm._v("欄目尚未開放使用")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }